module.exports = __webpack_public_path__ + "static/media/bopp_tape_dispenser.19c451d6.png";